import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Router} from "@angular/router";
import {CoreComponent} from "../core-component/core.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {EuOtpCodeLoginType} from "../../interfaces/core.types";
import {AuthService} from "../../service/auth.service";

@Component({
  selector: 'login-otp-phone',
  templateUrl: './login-otp-phone.component.html',
  styleUrls: ['./login-otp-phone.component.css']
})
export class LoginOtpPhoneComponent extends CoreComponent implements OnInit, OnDestroy {

  formGroup!: FormGroup;
  @Output() onStepComplete = new EventEmitter<number>;
  @Output() onEnteredContact = new EventEmitter<string>;

  visible: boolean = false;
  showValidation: boolean = false;

  constructor(
    protected authService: AuthService,
    protected router: Router,
    private fb: FormBuilder) {
    super();
  }

  override ngOnInit(): void {
    this.initComponent();

  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
    this.initForm();
  }


  /**
   * Destroy component.
   */
  override ngOnDestroy(): void {

  }
  initForm(){
    this.formGroup = this.fb.group({
      phone: ['', [
        Validators.required,
        Validators.pattern(/^[1-9][0-9]{5,13}$/)
      ]]
    });
  }
  handleStepComplete(): void {
    this.showValidation = true;

    if (this.formGroup?.invalid) {
      this.formGroup.markAllAsTouched();
      return;
    }
    let phone: string = this.formGroup.get('phone')?.value;
    phone = `+49${phone}`;

    this.busy = true;


    this.authService.otpLoginInitiate(EuOtpCodeLoginType.MOBILE_PHONE, phone).subscribe({
      next: () => {
        this.busy = false;
        this.onEnteredContact.emit(phone);
        this.onStepComplete.emit(3);
      },
      error: () => {
        this.busy = false;
        // Optionally show error message
      }
    });
  }

  navigateToLogin() {
    this.router.navigate(['/login'])
  }
  navigateBack() {
    this.onStepComplete.emit(0);
  }
}
